import Api from '../common/Api';
import {Backend, headers} from "../common/Config";
import Helpers from '../common/Helpers';

export default class Colaboradores {

    static async save(form) {
        const response = await Api.post({
            url: `${Backend}/colaborador/create`,
            form,
            headers: headers
        });
        return Helpers.dataReturn(response);
    };

    static async update(form) {
        const response = await Api.post({
            url: `${Backend}/colaborador/update`,
            form,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async get(page = 0) {
        const response = await Api.get({
            url: `${Backend}/colaborador/list/${page}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

    static async getById(id) {
        const response = await Api.get({
            url: `${Backend}/colaborador/get/${id}`,
            headers
        });
        return Helpers.dataReturn(response);
    };

}
